<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar';

withDefaults(
  defineProps<{
    // Label of the "proceed without validation" action (e.g. "Send anyway" / "Create anyway").
    sendLabel?: string;
  }>(),
  {
    sendLabel: 'Send anyway',
  },
);

defineEmits([...useDialogPluginComponent.emits]);

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent();

const retry = (): void => onDialogOK({ action: 'retry' });
const sendAnyway = (): void => onDialogOK({ action: 'send' });
const cancel = (): void => onDialogCancel();
</script>

<template>
  <q-dialog
    ref="dialogRef"
    @hide="onDialogHide"
  >
    <q-card class="validation-error-card column no-wrap">
      <q-card-section class="row items-center no-wrap q-gutter-sm">
        <q-icon
          name="cloud_off"
          color="warning"
          size="28px"
        />
        <div class="text-h6">
          Couldn't check the text
        </div>
      </q-card-section>

      <q-card-section class="q-pt-none text-body2 text-grey-8">
        The AI check is temporarily unavailable. You can try again, or send your text without checking.
      </q-card-section>

      <q-separator />

      <q-card-actions
        align="right"
        class="q-gutter-sm q-pa-md"
      >
        <q-btn
          label="Cancel"
          flat
          no-caps
          @click="cancel"
        />
        <q-btn
          :label="sendLabel"
          flat
          no-caps
          color="grey-8"
          @click="sendAnyway"
        />
        <q-btn
          label="Try again"
          icon="refresh"
          unelevated
          no-caps
          color="secondary"
          @click="retry"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped>
.validation-error-card {
  width: 440px;
  max-width: 90vw;
}
</style>
